"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformRouteTypeToString = transformRouteTypeToString;
const legacy_enums_1 = require("@daytrip/legacy-enums");
function transformRouteTypeToString(routeType) {
    switch (routeType) {
        case legacy_enums_1.RouteType.Car:
            return "car";
        case legacy_enums_1.RouteType.Ship:
            return "ship";
        default:
            return "";
    }
}
//# sourceMappingURL=transformRouteTypeToString.js.map